import styles from "./StatusBadge.module.css"

const StatusBadge = ({ label = "", color, appearance = "outline" }) => {


  return (
    <div className={styles.statusContainer}>
      <div className={`${styles.statusBadge} ${appearance === "soft" ? styles.soft : ""}`} style={{ "--color": color }}>
        {appearance === "soft" && <span className={styles.dot} aria-hidden="true" />}
        {appearance === "soft" ? label.charAt(0).toUpperCase() + label.slice(1).toLowerCase() : label.toUpperCase()}
      </div>
    </div>
  )
}

export default StatusBadge
